module.exports = __webpack_public_path__ + "static/media/exportIconButton.2ad0dd2f.svg";